<template>
    <div class="page-wrapper">
        <div class="page-content">
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                <div class="breadcrumb-title pe-3">Home</div>
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item">
                                <router-link to="/home"><i class="bx bx-home-alt"></i></router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">About Page</li>
                        </ol>
                    </nav>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">About Component UI CMS</h5>
                    <hr />
                    <div class="form-body mt-4" v-if="dataLoaded">
                        <div class="row mb-3">
                            <div class="col-md-3 mb-3">
                                <div class="input-group">
                                    <LvColorpicker label="Page Background Color:" v-model="cmsData.backgroundColor" :clearable="true" :bottomBar="true" :colors="colors"/>
                                </div>
                            </div>
                            <div class="col-md-3 mb-3">
                                <div class="input-group">
                                    <LvColorpicker label="Page Title Font Color:" v-model="cmsData.pageTitleFontColor" :clearable="true" :bottomBar="true" :colors="colors"/>
                                </div>
                            </div>
                            <div class="col-md-3 mb-3">
                                <div class="input-group">
                                    <LvColorpicker label="Section One Title Font Color:" v-model="cmsData.sectionOneTitleFontColor" :clearable="true" :bottomBar="true" :colors="colors"/>
                                </div>
                            </div>
                            <div class="col-md-3 mb-3">
                                <div class="input-group">
                                    <LvColorpicker label="Section Two Title Font Color:" v-model="cmsData.sectionTwoTitleFontColor" :clearable="true" :bottomBar="true" :colors="colors"/>
                                </div>
                            </div>
                            <div class="col-md-3 mb-3">
                                <div class="input-group">
                                    <LvColorpicker label="Location Section Title Font Color:" v-model="cmsData.locationSectionTitleFontColor" :clearable="true" :bottomBar="true" :colors="colors"/>
                                </div>
                            </div>
                            <div class="col-md-3 mb-3">
                                <div class="input-group">
                                    <LvColorpicker label="Dispo Difference Section Title Font Color:" v-model="cmsData.dispoDifferenceSectionTitleFontColor" :clearable="true" :bottomBar="true" :colors="colors"/>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-3 mb-3">
                                <div class="input-group">
                                    <LvColorpicker label="Location Slider Button Background Color:" v-model="cmsData.locationSliderShopNowButtonBackgroundColor" :clearable="true" :bottomBar="true" :colors="colors"/>
                                </div>
                            </div>
                            <div class="col-md-3 mb-3">
                                <div class="input-group">
                                    <LvColorpicker label="Location Slider Button Font Color:" v-model="cmsData.locationSliderShopNowButtonFontColor" :clearable="true" :bottomBar="true" :colors="colors"/>
                                </div>
                            </div>
                            <div class="col-md-3 mb-3">
                                <div class="input-group">
                                    <LvColorpicker label="Location Slider Button Hover Background Color:" v-model="cmsData.locationSliderShopNowButtonHoverBackgroundColor" :clearable="true" :bottomBar="true" :colors="colors"/>
                                </div>
                            </div>
                            <div class="col-md-3 mb-3">
                                <div class="input-group">
                                    <LvColorpicker label="Location Slider Button Hover Font Color:" v-model="cmsData.locationSliderShopNowButtonHoverFontColor" :clearable="true" :bottomBar="true" :colors="colors"/>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="d-grid">
                                <div class="d-grid gap-2 d-md-flex justify-content-md-start"> 
                                    <button class="btn btn-primary" @click="update" type="button">Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script src="../js/about-component-ui.js"></script>